<template>
  <Teleport to="#bk-toolbar-view-options">
    <button
      v-if="!ui.isMobile.value"
      ref="button"
      class="bk-toolbar-button"
      :class="{ 'bk-is-inactive': !isActive }"
      :style="{ order: weight || 0 }"
      @click.prevent.stop="onClick"
    >
      <slot name="icon">
        <Icon v-if="icon" :name="icon" />
      </slot>
      <div class="bk-tooltip">
        <span>{{ title }}</span>

        <ShortcutIndicator
          v-if="keyCode"
          meta
          :key-code="keyCode"
          :label="label"
          group="ui"
          @pressed="onClick"
        />
      </div>
    </button>
  </Teleport>

  <slot :is-active="isActive && !ui.isMobile.value" />
</template>

<script setup>
import { useBlokkli, computed, ref } from "#imports";
import { ShortcutIndicator, Icon } from "#blokkli/components";
import defineCommands from "#blokkli/helpers/composables/defineCommands";
import defineTourItem from "#blokkli/helpers/composables/defineTourItem";
const { storage, ui } = useBlokkli();
const props = defineProps({
  id: { type: String, required: true },
  label: { type: String, required: true },
  titleOn: { type: String, required: true },
  titleOff: { type: String, required: true },
  editOnly: { type: Boolean, required: false },
  keyCode: { type: String, required: false },
  icon: { type: null, required: false },
  tourText: { type: String, required: false },
  modelValue: { type: Boolean, required: false },
  weight: { type: [Number, String], required: false }
});
const emit = defineEmits(["update:modelValue"]);
const storageKey = "view_option_" + props.id;
const button = ref(null);
const isActiveStorage = storage.use(storageKey, false);
const isActive = computed({
  get() {
    return isActiveStorage.value;
  },
  set(v) {
    isActiveStorage.value = v;
    emit("update:modelValue", v);
  }
});
emit("update:modelValue", isActiveStorage.value);
const title = computed(() => isActive.value ? props.titleOff : props.titleOn);
const onClick = () => {
  isActive.value = !isActive.value;
};
defineCommands(() => {
  return {
    id: "plugin:view_option:" + props.id,
    label: title.value,
    icon: props.icon,
    group: "ui",
    callback: () => isActive.value = !isActive.value
  };
});
defineTourItem(() => {
  if (!props.tourText) {
    return;
  }
  return {
    id: "plugin:view_option:" + props.id,
    title: props.label,
    text: props.tourText,
    element: () => button.value
  };
});
</script>

<script>
export default {
  name: "PluginViewOption"
};
</script>
